<template>
    <div class="image-group pt-sm-12 mb-12">
        <v-container grid-list-xl>
            <v-layout row wrap white ma-1 text-center mb-12>
                <v-flex xs12 sm12 md12 lg12 x12>
                    <h3>Creado para todo tipo de negocio</h3>
                    <p class="body-1 mb-0">
                        Sislii soluciona las necesidades de diferentes tipos de negocios. Selecciona el tuyo y observa todo lo que Sislii puede hacer por ti
                    </p>
                </v-flex>
            </v-layout>
            <v-layout row wrap>
                <v-flex xs12 sm12 md6 lg4 xl4 v-for="item in data" :key="item.id">
                    <h6 class="text-center">{{ item.title }}</h6>
                    <div class="img-wrap">
                        <router-link :to="item.path">
                            <img v-lazyload :data-src="item.image" alt="producto" />
                        </router-link>
                    </div>
                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>

<script>
import lazyload from 'Directives/lazyload';
export default {
    props: ['data'],
    directives: {
        lazyload,
    },
};
</script>
